import { useActionHandlers } from './useActionHandlers';
import { useDialogState } from './useDialogState';
import { useTableData } from './useTableData';

export function useReportData() {
  const dialogState = useDialogState();
  const { tables, loading, handleRowClick } = useTableData(dialogState.searchParams, dialogState.showTable);
  const actionHandlers = useActionHandlers(async () => {
    // Refresh will be handled by useTableData when searchParams change
  });

  return {
    initialSearchDialogOpen: dialogState.initialSearchDialogOpen,
    editPrintTemplateDialogOpen: dialogState.editPrintTemplateDialogOpen,
    showTable: dialogState.showTable,
    searchParams: dialogState.searchParams,

    handleInitialSearchClose: dialogState.handleInitialSearchClose,
    handleInitialSearch: dialogState.handleInitialSearch,
    handleSearchClick: dialogState.handleSearchClick,
    handleEditPrintTemplateClick: dialogState.handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog: dialogState.handleClosePrintTemplateDialog,
    handleSavePrintTemplate: dialogState.handleSavePrintTemplate,

    tables,
    handleRowClick,
    isLoading: loading,
    error: null,
    refreshData: async () => {},

    handleRefreshClick: actionHandlers.handleRefreshClick,
    handleFixedColumnsClick: actionHandlers.handleFixedColumnsClick,
    handleExportDataClick: actionHandlers.handleExportDataClick
  };
}
